import { axiosAdminApiClient } from "..";
import { handleError } from "../../utils/errors";

class PaymentsService {
  initiateRaiffeisenPayment = async (orderData) => {
    try {
      const response = await axiosAdminApiClient.post(
        "/payments/raiffeisen/initiate",
        {
          orderData: orderData,
        },
        {
          withCredentials: true,
        },
      );

      if (response.status !== 200) {
        throw new Error("Failed to initiate payment");
      }

      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while initiating Raiffeisen payment",
      );
    }
  };

  // Provera stvarnog statusa porudžbine (koristi PaymentSuccess da ne veruje
  // slepo URL parametrima pre nego što isprazni korpu / prikaže uspeh).
  checkOrderStatus = async (orderNumber) => {
    const response = await axiosAdminApiClient.get(
      `/payments/raiffeisen/status/${orderNumber}`,
      { withCredentials: true },
    );
    return response.data;
  };
}

export default new PaymentsService();
